import { createSlice } from '@reduxjs/toolkit';

/**
 * @type { import(
 *   '../../apis/act/getUnregistListApiTypes'
 * ).UnregistListGetResponse }
 */
const initialState = {
  message: '',
  description: '',
  data: {
    total: 0,
    guidances: [],
  },
};

export const unregistListSlice = createSlice({
  name: 'unregistList',
  initialState,
  reducers: {
    updateUnregistList: (state, action) => {
      state.message = action.payload.message;
      state.description = action.payload.description;
      state.data = action.payload.data;
    },
  },
});

export const { updateUnregistList } = unregistListSlice.actions;

export default unregistListSlice.reducer;
